export default __webpack_public_path__ + "media/images/logo_transparent-d81d9009c185b37138a83e62fcaf75e9.svg";